import { render, staticRenderFns } from "./ComplaintType.vue?vue&type=template&id=6559b6f6&"
import script from "./ComplaintType.vue?vue&type=script&lang=js&"
export * from "./ComplaintType.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports